import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { APP_NAME, useTenantDisplayName } from "@/features/branding";

import { getContractLabelText } from "../helpers/get-contract-label-text";

/**
 * Resolves the display text for a legal document title the same way the
 * login agreement dialog does: known slugs map to translated labels, the
 * tenant's privacy policy interpolates the tenant name, anything else (for
 * example Stripe's hosted agreements) is shown verbatim.
 */
export const useContractLabel = () => {
  const { t } = useTranslation();
  const clientName = useTenantDisplayName() ?? APP_NAME;

  return useCallback(
    (title: string) => getContractLabelText(title, clientName, t),
    [clientName, t]
  );
};
